import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-8 overflow-x-auto min-h-[420px]" }
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_4 = { scope: "col" }
const _hoisted_5 = { class: "flex items-center justify-between w-full px-2 py-2 capitalize" }
const _hoisted_6 = {
  key: 0,
  class: "relative flex items-center justify-between px-2 py-2"
}
const _hoisted_7 = { scope: "col" }
const _hoisted_8 = { class: "flex items-center justify-between w-full px-2 py-2 capitalize" }
const _hoisted_9 = {
  key: 0,
  class: "relative flex items-center justify-between px-2 py-2"
}
const _hoisted_10 = {
  key: 0,
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = {
  key: 1,
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "capitalize" }
const _hoisted_16 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_17 = { class: "relative flex items-center justify-between px-2 py-2" }
const _hoisted_18 = { class: "capitalize" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = { class: "relative flex items-center justify-between px-2 py-2" }
const _hoisted_22 = { class: "capitalize" }
const _hoisted_23 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_24 = { scope: "col" }
const _hoisted_25 = { class: "relative flex items-center justify-between w-64 px-2 py-2" }
const _hoisted_26 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_27 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_28 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_29 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_30 = { class: "px-2" }
const _hoisted_31 = { class: "capitalize" }
const _hoisted_32 = { class: "px-2 py-2 whitespace-nowrap" }
const _hoisted_33 = {
  key: 0,
  class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal"
}
const _hoisted_34 = {
  key: 1,
  class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal"
}
const _hoisted_35 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_36 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_37 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_38 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_39 = { class: "px-2 py-2 whitespace-nowrap" }

import { PropType } from "vue";
import { storeToRefs } from "pinia";

import SortableTableHeader from "./SortableTableHeader.vue";
import SubscriptionBadge from "../SubscriptionBadge.vue";
import FilterTableHeader from "./FilterTableHeader.vue";
import PaginationBar from "../PaginationBar.vue";

import { useGlobalStore, useUserStore } from "@/store";
import { PaginationMeta, User } from "@/types";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersTable',
  props: {
  users: {
    type: Array as PropType<User[]>,
    required: true,
  },
  meta: {
    type: Object as PropType<PaginationMeta>,
    required: true,
  },
  hide_pagination: {
    type: Boolean,
    required: false,
    default: false,
  },
  filters: {
    type: Object as PropType<any>,
    required: false,
  },
  hideRolefilter: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["sort", "filter", "reset"],
  setup(__props, { emit: emits }) {

const { adminRoles, user } = storeToRefs(useUserStore());



const subStatusFilters = ["pending", "active", "expired", "none"];
const { countries, course_roles } = storeToRefs(useGlobalStore());

const hiddenRoles = ["professional", "paid-professional", "l3-trainee", "l3-specialist", "l4b-trainee", "l4b-mentor"];
var roles = [...course_roles.value, ...adminRoles.value]
  .filter(r => {
    if (userHasRole(user.value.roles, ["trainer-organisation"])) {
      // Exclude roles that are part of adminRoles if the user has the specified roles
      return (
        course_roles.value.some(c => c.name === r.name) && !adminRoles.value.some(a => a.name === r.name) && !hiddenRoles.includes(r.name) && r.name !== "facilitator-organisation"
      );
    }

    if (userHasRole(user.value.roles, ["facilitator-organisation"])) {
      // Exclude roles that are part of adminRoles if the user has the specified roles
      return (
        course_roles.value.some(c => c.name === r.name) && !adminRoles.value.some(a => a.name === r.name) && !hiddenRoles.includes(r.name) && r.name !== "trainer-organisation"
      );
    }

    return true; // Include all roles otherwise
  })
  .map(r => ({ key: r.display_name, value: r.name }));

const locations = countries.value.map(c => c.name);



const userCanSeeOrg = userHasRole(user.value.roles, ["admin", "users-admin", "courses-admin", "clubs-admin", "trainer-organisation", "facilitator-organisation"]);

function sortBy(col: string, dir: string) {
  emits("sort", col, dir);
}

function setFilter(col: string, value: string) {
  emits("filter", col, value);
}

function resetFilters() {
  emits("reset");
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", _hoisted_3, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("name")), 1),
                (__props.filters && !__props.hideRolefilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(SortableTableHeader, {
                        label: "last_name",
                        column: "last_name",
                        onSort: sortBy
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("email")), 1),
                (__props.filters && !__props.hideRolefilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(SortableTableHeader, {
                        label: "name",
                        column: "email",
                        onSort: sortBy
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(userCanSeeOrg))
              ? (_openBlock(), _createElementBlock("th", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("trained-by")), 1),
                    _createVNode(SortableTableHeader, {
                      column: "organisation_id",
                      onSort: sortBy
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(userCanSeeOrg))
              ? (_openBlock(), _createElementBlock("th", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("organisation")), 1),
                    _createVNode(SortableTableHeader, {
                      column: "sub_organisation",
                      onSort: sortBy
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("roles")), 1),
                (__props.filters && !__props.hideRolefilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(SortableTableHeader, {
                        column: "role",
                        onSort: sortBy
                      }),
                      _createVNode(FilterTableHeader, {
                        label: "role",
                        currentValue: __props.filters.role,
                        isObjectArray: true,
                        filters: _unref(roles),
                        onChange: setFilter,
                        onReset: resetFilters
                      }, null, 8, ["currentValue", "filters"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("region")), 1),
                (__props.filters)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(SortableTableHeader, {
                        label: "Region",
                        column: "country",
                        onSort: sortBy
                      }),
                      _createVNode(FilterTableHeader, {
                        label: "region",
                        currentValue: __props.filters.region,
                        filters: _unref(locations),
                        onChange: setFilter,
                        onReset: resetFilters
                      }, null, 8, ["currentValue", "filters"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("subscription-status")), 1),
                (__props.filters)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(SortableTableHeader, {
                        label: "Subscription Status",
                        column: "subscription_status",
                        onSort: sortBy
                      }),
                      _createVNode(FilterTableHeader, {
                        label: "subscription_status",
                        currentValue: __props.filters.subscription,
                        filters: subStatusFilters,
                        onChange: setFilter,
                        onReset: resetFilters
                      }, null, 8, ["currentValue"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`renewal-date`)), 1),
                _createVNode(SortableTableHeader, {
                  column: "subscription_end",
                  onSort: sortBy
                })
              ])
            ]),
            _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t("view")), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.users, (user) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400 odd:bg-gray-200",
              key: user.id
            }, [
              _createElementVNode("td", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1)
              ]),
              _createElementVNode("td", _hoisted_32, _toDisplayString(user.email), 1),
              (_unref(userCanSeeOrg))
                ? (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString(user.organisation ? user.organisation.name : _ctx.$t("no-trained-by")), 1))
                : _createCommentVNode("", true),
              (_unref(userCanSeeOrg))
                ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(user.sub_organisation ? user.sub_organisation : _ctx.$t("no-organisation")), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_35, _toDisplayString(user.roles.map(r => r.display_name).join(", ")), 1),
              _createElementVNode("td", _hoisted_36, _toDisplayString(user.country), 1),
              _createElementVNode("td", _hoisted_37, [
                _createVNode(SubscriptionBadge, {
                  subscription_status: user.subscription_status
                }, null, 8, ["subscription_status"])
              ]),
              _createElementVNode("td", _hoisted_38, _toDisplayString(user.subscription_end === null ? "" : new Date(user.subscription_end).toDateString()), 1),
              _createElementVNode("td", _hoisted_39, [
                _createVNode(_component_router_link, {
                  to: `/dashboard/users/${user.id}`,
                  class: "underline text-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (!__props.hide_pagination)
      ? (_openBlock(), _createBlock(PaginationBar, {
          key: 0,
          meta: __props.meta
        }, null, 8, ["meta"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})